import React, { useMemo } from 'react';
import { Dropdown } from 'tea-component';
import Result from './components/Result';
import Selector from './components/Selector';
import useResult from './hooks/useResult';
import type { VersionDateProps } from '../../../types';
import './index.scss';

const RangeDayMonthSelector = ({
  type,
  defaultType,
  value,
  defaultValue,
  onConfirm,
  onCancel,
}: VersionDateProps) => {
  const { resultType, result, handleCancel, handleConfirm } = useResult({
    value,
    defaultValue,
    onConfirm,
    onCancel,
    type,
    defaultType,
  });

  const dropdownButton = useMemo(() => {
    return <Result type={resultType} value={result} />;
  }, [result, resultType]);

  return (
    <Dropdown
      clickClose={false}
      style={{ marginRight: 10 }}
      button={dropdownButton}
      className="range-day-month-selector__header-wrapper"
      boxStyle={{ padding: 0 }}
    >
      {(close) => (
        <Selector
          defaultValue={result}
          defaultType={resultType}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          close={close}
        />
      )}
    </Dropdown>
  );
};

export default RangeDayMonthSelector;
